import React, { ReactElement } from "react";

import { ChatTopic } from "../ChatTopic";
import { SuggestedTopicsProps } from "./SuggestedTopics.types";

export const SuggestedTopics = ({
  className,
  isApiLoading,
  topics = [],
  clickToSubmit,
  setValue,
  ...rest
}: SuggestedTopicsProps): ReactElement => {
  return (
    <section
      style={{
        display: isApiLoading ? "none" : "block",
      }}
    >
      <div
        className={className}
        style={{
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
        }}
        {...rest}
      >
        {topics.map(({ title, description }) => (
          <ChatTopic
            key={title}
            onClick={(): void => {
              setValue?.(title);
              clickToSubmit?.(title);
            }}
            description={description}
          >
            {title}
          </ChatTopic>
        ))}
      </div>
    </section>
  );
};
